const dummyOnClose = () => {}

interface Props {
  onClose: (() => void) | null | undefined
  locked: boolean
}
interface ReturnType {
  defaultOpen: boolean
  closeOnEsc: boolean
  closeOnOutsideClick: boolean
  onClose: () => void
}

const usePortalConfiguration = ({ onClose, locked }: Props): ReturnType => {
  const closeOnEsc = !locked
  const onCloseFn = !locked && onClose ? onClose : dummyOnClose

  return {
    closeOnEsc,
    onClose: onCloseFn,
    closeOnOutsideClick: false,
    defaultOpen: true,
  }
}

export default usePortalConfiguration
